import { Fragment, useEffect, useRef, useState } from "react";
import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { BonusUiTitle, TourTitle } from "../../../Utils/Constants";
import TourMain from "./TourMain";
import { toast } from "react-toastify";
import { TourGuideClient } from "@sjmc11/tourguidejs";
import { toursteps } from "../../../Data/BonusUiData/TourData";

export default function TourContainer() {
  const tourRef = useRef<any | null>(null);
  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(() => {
    try {
      tourRef.current = new TourGuideClient({ steps: toursteps });
    } catch (error) {
      toast.error("Error initializing TourGuideClient:" + error);
    }

    return () => tourRef.current?.destroy?.();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setIsTourOpen(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isTourOpen) tourRef.current?.start?.();
  }, [isTourOpen]);
  return (
    <Fragment>
      <Breadcrumbs pageTitle={TourTitle} parent={BonusUiTitle} title={TourTitle} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <TourMain />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
}
